
import React from 'react';

import { useMessage } from "./message_context";

const tokenContext = React.createContext();

const {Provider} = tokenContext;

async function checkTokenAndPermissions(token) {
    const res = await fetch("/api/check_token/" + token);
    const res_data = await res.json();
    if (res_data.rc == "ok") {
        return {
            use_token: res_data.use_token,
            permissions: res_data.permissions
        }
    } else {
        return false
    };
}

// custom provider
export const TokenProvider = ({children}) => {

    const [token, setToken] = React.useState({
        token: undefined,
        validated: false,
        permissions: [],
    })

    async function setAndValidateToken(token) {
        if (token) {
            setToken({
                token: token,
                validated: false,
                permissions: [],
            });
            const rc = await checkTokenAndPermissions(token);
            if (!rc) {
                setToken({
                    token: "",
                    validated: false,
                    permissions: [],
                });
            } else {
                setToken({
                    token: rc.use_token || token,
                    validated: true,
                    permissions: rc.permissions,
                });
                return true;
            };
        };
        return false;
    };

    React.useEffect(() => {

        async function fetchit() {
            const uri_parts = window.location.href.split("/");
            const possible_token = uri_parts.at(-1);
            if (possible_token) {
                const ok = await setAndValidateToken(possible_token)
                document.getElementById('token_modal').close();
            }
        };
        fetchit();


    }, []);

  return (
    <Provider value={{token, setAndValidateToken}}>
      {children}
    </Provider>
  )
}

export const useToken = () => {
        return React.useContext(tokenContext);
};


